export const select_company = `Select Company`
export const reportView = `Report View`
export const selectState = `Select State`
export const selectCity='Select City'
export const reportType='Report Type'
export const gstIn='Select GSTIN'
export const selectBranches='Select Branches'
export const selectVehicle='Select Vehicle'

export const generateMemo='Generate Memo'
export const inclGSTComm='Incl. GST on Comm.?'
export const offlineBooking='Offline Booking'
export const toPayHamali='To Pay Hamali'